<!-- HEADER -->
<mat-toolbar
  color="primary"
  class="app-toolbar">
  <span class="app-logo">{{logo}}</span>
  <span class="app-name">{{name}}</span>
  <span class="toolbar-spacer"></span>

  <img
    class="app-img-logo-right"
    [src]="logoImageSrc"
    alt="logo">
</mat-toolbar>
<!-- HEADER-END -->

<!-- MAIN-CONTENT -->
<mat-sidenav-container class="app-container">
  <mat-sidenav
    class="app-sidebar"
    mode="side"
    [opened]="opened">
    <lib-menu
      [userInfo]="userInfo"
      [menu]="menu"></lib-menu>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <!-- TOOLBAR-USER-MENU -->
    <mat-toolbar class="app-sub-toolbar">
      <button
        mat-icon-button
        (click)="handleToogleMenu()">
        <mat-icon
          aria-hidden="false"
          aria-label="sidebar icon">
          menu
        </mat-icon>
      </button>

      <ng-container *ngTemplateOutlet="toolbarElementsTemplate;"></ng-container>

      <span class="toolbar-spacer"></span>
      <span class="toolbar-label-username">{{userInfo.name}}</span>
      <button mat-icon-button>
        <mat-icon
          aria-hidden="false"
          aria-label="sidebar icon">
          account_circle
        </mat-icon>
      </button>
    </mat-toolbar>
    <!-- TOOLBAR-USER-MENU-END -->
    <div class="main-content">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!-- MAIN-CONTENT-END -->

<footer class="app-footer">
  <div class="footer-content">
    Plataforma de los Sistemas de Información de la Oficina General de la Administración - SIOGA v1
  </div>
</footer>
